/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('header').addClass('fixed');
      } else {
        $('header').removeClass('fixed');
      }
    });

  $("#main-menu > ul > li:has('ul') > a").before('<span class="menu-open"></span>');
  
  var 
    overlay = $(".overlay-screen");
    menubtn = $("a#menu-btn");

  $(menubtn).on("click", function(e){
    $("body").addClass("no-scroll");
    $(overlay).addClass("is-visible");
     e.preventDefault();
  });

  $('.close-menu').on("click", function(e){
    $("body").removeClass("no-scroll");
    $(overlay).removeClass("is-visible");
     e.preventDefault();
  });

  $(".menu-open").click(function() {
      $(this).parent().children('ul.sub-menu').slideToggle();
       $(this).parents('li.menu-item-has-children').toggleClass('active').siblings().removeClass('active');
      $('.menu-open').not(this).parent().children('ul.sub-menu').slideUp();
      $(this).toggleClass('more');
      $('.menu-open').not(this).removeClass('more');
  });

  $('#hero-slideshow').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      rows: 0,
      dots:true,
      arrows:false,
      dotsClass: 'custom-dots',
      customPaging: function(slider, i) {
        return '<a href="javascript:void(0)"></a>';
      },
    });

})(jQuery); // Fully reference jQuery after this point.
